import { FreightSnapScan } from '../../../../helpers/FreightSnap/types'
import { CheckIcon, ClockIcon, HeightIcon, RulerIcon, WeightIcon } from './DimensionerIcons'
import MeasurementStatCard from './MeasurementStatCard'

interface Props {
    scan: FreightSnapScan | null
    hasData: boolean
    uom: string
    wUom: string
    metric?: boolean
    error?: string | null
}

const round = (n: number) => Math.round((n || 0) * 100) / 100

const MeasurementGrid = ({scan, hasData, uom, wUom, metric, error}: Props) => {
    const dim = (v: number) => metric ? round(v * 2.54) : v
    const wgt = (v: number) => metric ? round(v * 0.45359237) : v
    return (
    <>
        <div className="d-flex align-items-center justify-content-between mb-3">
            <span className="text-uppercase" style={{fontSize: 10, fontWeight: 600, letterSpacing: '.06em', color: '#A1A5B7'}}>Measurements</span>
            {hasData
                ? <span className="badge badge-light-success d-flex align-items-center"><CheckIcon size={12}/><span className="ms-1">Scan complete</span></span>
                : error
                    ? <span className="d-flex align-items-center" style={{fontSize: 11, fontWeight: 600, color: '#e42e5b'}}>Scan failed</span>
                    : <span className="d-flex align-items-center" style={{fontSize: 11, fontWeight: 500, color: '#B5B5C3'}}><ClockIcon size={12}/><span className="ms-1">Awaiting scan</span></span>
            }
        </div>
        {error && !hasData && (
            <div style={{display: 'flex', gap: 8, background: '#FEF4F6', border: '1px solid #F3C7D2', borderRadius: 8, padding: '10px 12px', marginBottom: 14, fontSize: 12, fontWeight: 500, color: '#D9496E', lineHeight: 1.4}}>
                {error}
            </div>
        )}
        <div style={{display: 'grid', gridTemplateColumns: 'repeat(4, minmax(0, 1fr))', gap: 8, marginBottom: 14}}>
            <MeasurementStatCard icon={<WeightIcon size={13}/>} label="Weight" value={hasData ? wgt(scan!.weight) : ''} unit={wUom} hasData={hasData}/>
            <MeasurementStatCard icon={<RulerIcon size={13}/>} label="Length" value={hasData ? dim(scan!.length) : ''} unit={uom} hasData={hasData}/>
            <MeasurementStatCard icon={<RulerIcon size={13}/>} label="Width" value={hasData ? dim(scan!.width) : ''} unit={uom} hasData={hasData}/>
            <MeasurementStatCard icon={<HeightIcon size={13}/>} label="Height" value={hasData ? dim(scan!.height) : ''} unit={uom} hasData={hasData}/>
        </div>
    </>
    )
}

export default MeasurementGrid
